(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
$.fn.dateTimeSelect = function (initialDate) {

  if (initialDate === 'destroy') {

    this.each(function (index, element) {
      $(element).datetimepicker('destroy')
    })

    $('#ui-datepicker-div').remove()

    return this
  }

  this.datetimepicker(
    { dateFormat: 'DD dd MM yy,'
    , timeFormat: 'HH:mm'
    , showOtherMonths: true
    })

  return this

}

}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/admin/source/js/app/lib/dateTimeSelect.jquery.js","/admin/source/js/app/lib")
//# sourceMappingURL=data:application/json;charset:utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImFkbWluL3NvdXJjZS9qcy9hcHAvbGliL2RhdGVUaW1lU2VsZWN0LmpxdWVyeS5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBQUE7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQSIsImZpbGUiOiJnZW5lcmF0ZWQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlc0NvbnRlbnQiOlsiJC5mbi5kYXRlVGltZVNlbGVjdCA9IGZ1bmN0aW9uIChpbml0aWFsRGF0ZSkge1xuXG4gIGlmIChpbml0aWFsRGF0ZSA9PT0gJ2Rlc3Ryb3knKSB7XG5cbiAgICB0aGlzLmVhY2goZnVuY3Rpb24gKGluZGV4LCBlbGVtZW50KSB7XG4gICAgICAkKGVsZW1lbnQpLmRhdGV0aW1lcGlja2VyKCdkZXN0cm95JylcbiAgICB9KVxuXG4gICAgJCgnI3VpLWRhdGVwaWNrZXItZGl2JykucmVtb3ZlKClcblxuICAgIHJldHVybiB0aGlzXG4gIH1cblxuICB0aGlzLmRhdGV0aW1lcGlja2VyKFxuICAgIHsgZGF0ZUZvcm1hdDogJ0REIGRkIE1NIHl5LCdcbiAgICAsIHRpbWVGb3JtYXQ6ICdISDptbSdcbiAgICAsIHNob3dPdGhlck1vbnRoczogdHJ1ZVxuICAgIH0pXG5cbiAgcmV0dXJuIHRoaXNcblxufVxuIl19